module.exports = __webpack_public_path__ + "img/consecuencia7.0fc7feef.png";